// extracted by mini-css-extract-plugin
export default {"container":"style_container__jbPb3","lei-title":"style_lei-title__2leAA","tabs":"style_tabs__6Ihow","back":"style_back__hRgvF","active-tab":"style_active-tab__iUHLV"};